import * as React from "react";
import { IPatientSurgeryAndProcedure } from "@curefit/ehr-common";
import * as _ from "lodash"
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientSurgeryViewProps {
    surgeries: IPatientSurgeryAndProcedure[],
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

class PatientSurgeryView extends React.Component<PatientSurgeryViewProps> {

    constructor(props: PatientSurgeryViewProps) {
        super(props);
    }

    render() {
        let surgeries = this.props.surgeries;
        return (
            <div className="patient-surgery-view">
                {
                    !_.isEmpty(this.props.questionnaire) &&
                    <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
                }
                {
                    surgeries.length ?
                    _.map(surgeries, function(surgery: IPatientSurgeryAndProcedure, index: number){
                        return (
                            <div className="surgery-tag round-tag" key={index}>
                                <div className="surgery-name">{surgery.displayValue}</div>
                                <div className="surgery-year">{surgery.year}</div>
                            </div>
                        )
                    }) : <div className={"no-record-found-label"}>No surgery history found</div>
                }
            </div>
        );
    }
}

export default PatientSurgeryView